// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

form {
  margin: 10px;
  display: flex;
  gap: var(--content-gutter);
}

.embed-button {
  padding: 0;
  position: absolute;
  top: 8px;
  right: -8px;
}

input.hide-counter::-webkit-outer-spin-button,
input.hide-counter::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input.hide-counter[type=number] {
  -moz-appearance: textfield;
}

.toolbar {
  margin-top: 20px;
  margin-bottom: -5px;
  height: unset !important;
}

.controls {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: calc(var(--content-gap) / 2);
  padding-top: 1rem;
}

.chart {
  height: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  position: relative;
}

#explore-chart {
  flex-basis: 80%;
}

#explore-chart-overview {
  flex-basis: 20%;
}

.hidden {
  display: none;
}

#no-files {
  padding: 20px;
  background: rgba(255, 0, 0, 0.1);
  margin: 20px;
}

ngx-monaco-editor {
  object-fit: fill;
  height: calc(100% - 110px) !important;
}

#data-container {
  position: relative;
}

.display-count {
  position: absolute;
  top: 10px;
  z-index: 1000;
  color: rgba(255, 255, 255, 0.5);
  left: 40px;
  font-size: 0.8em;
}

.display-count mat-spinner {
  display: inline-block !important;
  height: 9px !important;
  width: 9px !important;
}

.full-height {
  height: 100%;
}

mat-spinner {
  position: absolute;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  opacity: 0.5;
}

::ng-deep .mat-mdc-select-panel {
  background-color: var(--mat-sys-surface-container) !important;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar {
  width: 8px !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-track {
  background: transparent !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option {
  color: var(--mat-sys-on-surface) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option:hover:not(.mdc-list-item--disabled) {
  background-color: var(--mat-sys-surface-variant) !important;
}
::ng-deep .mat-mdc-select-panel .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) {
  background-color: var(--mat-sys-primary-container) !important;
  color: var(--mat-sys-on-primary-container) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/explore-chart/explore-chart.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,0BAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;;EAEE,wBAAA;EACA,SAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;EACE,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,qCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,+BAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,gCAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAGA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;AAAF;;AAKE;EACE,6DAAA;EAGA,gCAAA;EACA,gEAAA;AAJJ;AAMI;EACE,qBAAA;AAJN;AAOI;EACE,kCAAA;AALN;AAQI;EACE,+CAAA;EACA,6BAAA;AANN;AAQM;EACE,+CAAA;AANR;AAUI;EACE,2CAAA;AARN;AAUM;EACE,2DAAA;AARR;AAWM;EACE,6DAAA;EACA,qDAAA;AATR","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\nform {\n  margin: 10px;\n  display: flex;\n  gap: var(--content-gutter);\n}\n\n.embed-button {\n  padding: 0;\n  position: absolute;\n  top: 8px;\n  right: -8px;\n}\n\ninput.hide-counter::-webkit-outer-spin-button,\ninput.hide-counter::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput.hide-counter[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.toolbar {\n  margin-top: 20px;\n  margin-bottom: -5px;\n  height: unset !important;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: calc(var(--content-gap) / 2);\n  padding-top: 1rem;\n}\n\n.chart {\n  height: calc(100% - 100px);\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n#explore-chart {\n  flex-basis: 80%;\n}\n\n#explore-chart-overview {\n  flex-basis: 20%;\n}\n\n.hidden {\n  display: none;\n}\n\n#no-files {\n  padding: 20px;\n  background: rgba(255, 0, 0, 0.1);\n  margin: 20px;\n}\n\nngx-monaco-editor {\n  object-fit: fill;\n  height: calc(100% - 110px) !important;\n}\n\n#data-container {\n  position: relative;\n}\n\n.display-count {\n  position: absolute;\n  top: 10px;\n  z-index: 1000;\n  color: rgba(255, 255, 255, 0.5);\n  left: 40px;\n  font-size: 0.8em;\n}\n\n.display-count mat-spinner {\n  display: inline-block!important;\n  height: 9px!important;\n  width: 9px!important;\n}\n\n.full-height {\n  height: 100%;\n}\n\n\nmat-spinner {\n  position: absolute;\n  top: calc(50% - 50px);\n  left: calc(50% - 50px);\n  opacity: 0.5;\n}\n\n// Fix dropdown styling - ensure proper theming\n::ng-deep {\n  .mat-mdc-select-panel {\n    background-color: var(--mat-sys-surface-container) !important;\n\n    // Themed scrollbar for dropdown list\n    scrollbar-width: thin !important;\n    scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n    &::-webkit-scrollbar {\n      width: 8px !important;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: transparent !important;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: rgba(155, 155, 155, 0.7) !important;\n      border-radius: 4px !important;\n\n      &:hover {\n        background: rgba(155, 155, 155, 0.9) !important;\n      }\n    }\n\n    .mat-mdc-option {\n      color: var(--mat-sys-on-surface) !important;\n\n      &:hover:not(.mdc-list-item--disabled) {\n        background-color: var(--mat-sys-surface-variant) !important;\n      }\n\n      &.mdc-list-item--selected:not(.mdc-list-item--disabled) {\n        background-color: var(--mat-sys-primary-container) !important;\n        color: var(--mat-sys-on-primary-container) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
